import { axiosInstance } from "@/lib/axiosInstance";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({
    url,
    method,
    data,
    params,
    headers,
  }: {
    url: string;
    method: any;
    data?: any;
    params?: any;
    headers?: any;
  }) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    fetchOrders: builder.query({
      query: () => ({ url: "/orders", method: "get" }),
    }),
    createOrder: builder.mutation({
      query: (data) => ({ url: "/orders", method: "post", data }),
    }),
    createExpressOrder: builder.mutation<any, any>({
      query: (data) => ({
        url: '/orders/express',  // Update the endpoint URL
        method: 'POST',
        data: {
          expressServiceName: data.expressServiceName,
          expressServiceCost: data.expressServiceCost,
          plateNumber: data.plateNumber,
          company: data.company,
          employee: data.employee,
          employees: data.employees
        }
      }),
    }),
  }),
});

export const { useFetchOrdersQuery, useCreateOrderMutation, useCreateExpressOrderMutation } = orderApi;
